
import { Component, Prop, Vue } from "vue-property-decorator";
import ProduceNav from "@/components/product/ProductNav.vue";
import ProduceNavVue from "@/components/product/ProductNav.vue";
import { RouterHelper } from "@/router/routerHelper";

@Component({
  components: {
    "product-nav": ProduceNavVue,
  },
})
export default class LiteBeeBrix3Vue extends Vue {
  tabList: Array<any> = RouterHelper.getProdRouterConfig("liteBeeBrix3");

  mounted() {
    new (<any>window).WOW().init();
  }
}
